import { Types } from "../actions/payPeriodActions";
import _ from "lodash";
import { NotificationManager } from "react-notifications";

import cleanDeep from "clean-deep";

const defaultState = {
	my: {},
};

const payPeriodReducers = (state = defaultState, action) => {
	console.log("inpayPeriodReducers", action.type);
	switch (action.type) {
		case Types.PAYPERIOD_UPDATING: {
			let newState = _.cloneDeep(state);

			newState.payPeriods.updating = true;

			return newState;
		}
		case Types.PAYPERIOD_UPDATE: {
			let newState = { ...state };

			console.log("inPayslipUpdate");
			newState.payPeriods.periods = Array.isArray(action.payload)
				? action.payload?.map((item) => ({ ...item, link: `${item.paySchedule}` }))
				: [];

			// if (action.payload[0] && action.payload[0].name){
			//   newState.fssReports = _.orderBy(action.payload,['name'],['asc'])
			// }

			newState.payPeriods.updating = false;
			// console.log('inPayslipUpdate',newState.payPeriods)

			return newState;
		}
		case Types.PAYPERIOD_UPDATE_SINGLE: {
			let newState = _.cloneDeep(state);
			const index = newState.payPeriods.periods.findIndex((i) => i.id == action.response.payPeriodId);

			newState.payPeriods.periods[index] = {
				...newState.payPeriods.periods[index],
				FPSStatus: action.response.submissionStatus,
			};

			return newState;
		}
		case Types.PAYPERIOD_DOWNLOADING: {
			let newState = _.cloneDeep(state);
			const index = newState.payPeriods.periods.find((i) => i.id == action.id);

			newState.payPeriods.periods[index] = { ...newState.payPeriods.periods[index], downloading: action.status };

			return newState;
		}
		case Types.PAYPERIOD_SET_HMRC_ERRORS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payrollHistory.hmrcErrorsModal = {
				open: action.open,
				period: action.period || state?.payrollHistory?.hmrcErrorsModal?.period,
			};

			return newState;
		}
		default:
			return state;
	}
};

export default payPeriodReducers;
